export enum PhoneNumbCheckStatus{
    LOADING= 'loading',
    WARNING= 'warning',
    SUCCESS= 'success',
    ERROR= 'error',
}

export enum ProductTypes {
    KITCHEN = 'kitchen',
    GROCERY = 'grocery',
}

export enum OrderTypes {
    INSTANT = 'Instant',
    GROCERY = 'grocery',
    BULKORDER = 'bulkorder'
}

export enum LoginRoles{
    SUPERADMIN = 'superadmin',
    ZONEADMIN = 'zoneadmin',
    TELECALLER = 'telecaller',
    EVENTADMIN = 'eventadmin',
    TEMPLEADMIN = 'templeadmin',
}
